export const ADDITIONAL_TREATMENT_STATES = {
  AVAILABLE: 'AVAILABLE',
  AVAILABLE_FOR_REFILL: 'AVAILABLE_FOR_REFILL',
  LOCKED: 'LOCKED',
  LOCKED_BEFORE_CONSULT: 'LOCKED_BEFORE_CONSULT',
  LOCKED_WAITING_REFILL: 'LOCKED_WAITING_REFILL',
  REQUEST_SUBMITTED: 'REQUEST_SUBMITTED',
  PRESCRIPTION_ISSUED: 'PRESCRIPTION_ISSUED',
} as const;

export type AdditionalTreatmentCardState =
  (typeof ADDITIONAL_TREATMENT_STATES)[keyof typeof ADDITIONAL_TREATMENT_STATES];

export type AdditionalTreatmentTypeName = 'ed' | 'pe' | 'hair_loss' | 'hsv';

export type AdditionalTreatmentItem = {
  id: string;
  treatmentTypeName: AdditionalTreatmentTypeName;
  state: AdditionalTreatmentCardState;
};
